<template>
  <div v-if="filter.input === 'text'">
    <input-text
      :label="filter.name"
      @update-value="updateFilter(filter.key, $event)"
    />
  </div>
  <div
    v-else-if="
      filter.input === 'select' &&
      filter.options &&
      filter.optionLabel &&
      filter.optionId
    "
  >
    <input-select
      :label="filter.name"
      :options="filter.options"
      :optionlabel="filter.optionLabel"
      :optionvalue="filter.optionId"
      @update-value="updateFilter(filter.key, $event)"
      option-show-all
    />
  </div>
  <div v-else-if="filter.input === 'check'">
    <input-check
      :label="filter.name"
      @update-value="updateFilter(filter.key, $event)"
    />
  </div>
</template>

<script>
const InputText = require("@/modules/input/components/InputText.vue").default;
const InputCheck = require("@/modules/input/components/InputCheck.vue").default;
const InputSelect = require("@/modules/input/components/InputSelect.vue")
  .default;

import { Filter } from "@/mixins/models/Filter";

export default {
  name: "WdFilterInput",
  data() {
    return {};
  },
  props: {
    filter: {
      type: Filter,
      required: true,
    },
  },
  components: {
    InputText,
    InputCheck,
    InputSelect,
  },
  methods: {
    updateFilter(Key, Value) {
      this.$emit("update-filter", { key: Key, value: Value });
    },
  },
  computed: {},
  created() {},
};
</script>